import React from "react";

import styles from "./HollowTable.module.scss";

function HollowTable({ titles, children }) {
  return (
    <>
      <table className={styles.table}>
        <thead>
          <tr className={styles.header}>
            {titles.map((title) => (
              <th>{title}</th>
            ))}
          </tr>
        </thead>

        {!!children.length && <tbody>{children}</tbody>}
      </table>
      {!children.length && (
        <span className={styles.noDataAvailable}>No Data Available</span>
      )}
    </>
  );
}

export default HollowTable;
